import { schema } from 'normalizr';

const voucherSchema = new schema.Entity('vouchers');

export default voucherSchema;
